export default __webpack_public_path__ + "static/media/flagship.d416ddfc.svg";